import { useState, useRef } from 'react'
import useSmallScreen from '../../utils/hooks/useSmallScreen'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardActionArea,
  Fab,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import PersonIcon from '@mui/icons-material/PersonOutline'
import { Link, generatePath } from 'react-router-dom'
import routes from '../routes'
import AppBar from '../../components/AppBar'
import Wrapper from '../../components/Wrapper'
import createIdeaImage from './createIdeaImage.png'
import FabWrapper from '../../components/FabWrapper'
import { ideasState, sessionState } from '../../state'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { getAuth } from 'firebase/auth'

const Ideas = () => {
  const isSmallScreen = useSmallScreen()
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const menuAnchorEl = useRef(null)
  const { data: ideas, loading } = useRecoilValue(ideasState)
  const resetIdeas = useResetRecoilState(ideasState)
  const { user } = useRecoilValue(sessionState)

  return (
    <>
      <AppBar
        title={isSmallScreen ? 'Ideas' : 'cobotfounder'}
        actions={
          <>
            {!user && (
              <Button
                color='primary'
                size='small'
                component={Link}
                to={routes.signin}
                variant='contained'
              >
                Sign In
              </Button>
            )}
            {user && (
              <>
                <IconButton
                  edge='end'
                  onClick={() => setOpenMenu(true)}
                  ref={menuAnchorEl}
                  aria-label='more options menu'
                >
                  <PersonIcon />
                </IconButton>

                <Menu
                  open={openMenu}
                  anchorEl={menuAnchorEl.current}
                  onClose={() => setOpenMenu(false)}
                >
                  <MenuItem
                    onClick={() => {
                      resetIdeas()
                      getAuth().signOut()
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </>
            )}
          </>
        }
      />

      <Wrapper maxWidth='lg'>
        <>
          {!isSmallScreen && !!ideas?.length && (
            <Box ml={2} mb={3}>
              <Typography variant='h4' component='h1'>
                Ideas
              </Typography>
            </Box>
          )}

          {(!user || (!loading && !ideas?.length)) && (
            <Box textAlign='center' mt={15}>
              <Box mb={10}>
                <img alt='start idea' src={createIdeaImage} />
              </Box>
              <Button
                variant={!user ? 'outlined' : 'contained'}
                color='primary'
                size='large'
                component={Link}
                to={user ? routes.newIdea : routes.signin}
              >
                start idea
              </Button>
            </Box>
          )}

          {!!ideas?.length && (
            <>
              <Grid container spacing={1}>
                {ideas.map(idea => (
                  <Grid item xs={12} sm={6} key={idea.id}>
                    <Card
                      variant='outlined'
                      sx={{
                        height: '100%',
                        minHeight: 120
                      }}
                    >
                      <CardActionArea
                        sx={{
                          height: '100%',
                          minHeight: 120
                        }}
                        component={Link}
                        to={generatePath(routes.idea, { ideaId: idea.id })}
                      >
                        <CardContent>
                          <Typography
                            variant={isSmallScreen ? 'h6' : 'h5'}
                            gutterBottom
                          >
                            {idea.name}
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            {idea.problemDescription}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <FabWrapper>
                <Fab
                  component={Link}
                  to={routes.newIdea}
                  color='primary'
                  variant={isSmallScreen ? 'circular' : 'extended'}
                >
                  <AddIcon />
                  {!isSmallScreen && (
                    <Box component='span' mx={1}>
                      Add Idea
                    </Box>
                  )}
                </Fab>
              </FabWrapper>
            </>
          )}
        </>
      </Wrapper>
    </>
  )
}

export default Ideas
